define('Components/EngagementsWidget/js/models/EngagementsWidgetInstanceModel',['underscore','backbone','WidgetInstanceModel','app'],function(_,Backbone,WidgetInstanceModel,app){

    var EngagementsModel = Backbone.Model.extend({
        getTitle:function(){
            return this.get('title');
        },
        getCTAUrl:function(){
            return this.get('calltoactiontarget');
        },
        getCTAText:function(){
            return this.get('calltoactiontext');
        },
        getImageId:function(){
            return this.get('image');
        },
        getImage: function(suffix,format){

            // default picture settings
            suffix = suffix ? suffix : '1080x1080';
            format = format ? format : 'JPG';

            var id_picture = this.get('image'),
                url = app.getPictureUrl(id_picture,'Widget',suffix,format,this.getTitle());
            if(url){
                return url
            }else{
                return app.getThemeUrl()+'engagementss/img/demo/sct4-visual.jpg'
            }
        },
        getVideo: function(){
            if(this.get('videourl') && this.get('videourl') != ''){
                return app.getThemeUrl()+'engagementss/videos/strat1.mp4';
            }else{
                return false;
            }
        }
    });

    return WidgetInstanceModel.extend({
        name:'EngagementsWidgetModel',

        isUnique:function(){
            return this.getEngagementss().size() == 1;
        },
        getNbItems:function(){
            return Math.min(parseInt(this.p('nbItems')), 4);
        },
        getEngagementsAsObject:function(n){
            // transforme les params en objets
            var model = this,
                active = model.p('active'+n)=='1',
                title = model.p('title'+n);
            return {
                active:active,
                title:title,
                id:n,
                videourl:model.get('params')['videourl'+n],
                image:model.p('image'+n),
                calltoactiontext:model.p('calltoactiontext'+n),
                calltoactiontarget:model.p('calltoactiontarget'+n)
            }
        },
        getEngagementss:function(){
            var model = this,
                engagementsCollection = model.engagementsCollection;
            if(!engagementsCollection){
                engagementsCollection = model.engagementsCollection = new Backbone.Collection();
                engagementsCollection.model = EngagementsModel;
                for(var i=1; i<=4; i++){
                    var attributes = model.getEngagementsAsObject(i);
                    if(attributes.active){
                        engagementsCollection.add(attributes);
                    }
                }
            }
            return engagementsCollection;
        },
    })
});
